import Vue from 'vue'
import VueRouter from 'vue-router'

import AboutPage from './component/about/about-page.vue'
import AboutProfile from './component/about/profile.vue'
import AboutTeams from './component/about/teams.vue'
import AboutCorporateGovernance from './component/about/corporate-governance.vue'
import PersonPage from './component/about/person.vue'


import ContactPage from './component/contact/contact-page.vue'

import DisclaimerPage from './component/disclaimer/disclaimer-page.vue'

import NewsPage from './component/news/news-page.vue'
import NewsFinancial from './component/news/financial.vue'
import NewsAnnouncement from './component/news/announcements.vue'
import NewsCircular from './component/news/circular.vue'
import NewsMedia from './component/news/media.vue'

import PortfolioPage from './component/portfolio/portfolio-page.vue'
import PortfolioCompanyList from './component/portfolio/company-list.vue'
import PortfolioCompanyDetail from './component/portfolio/company-detail.vue'

import SocialProjectPage from './component/about/social-project/portfolio-page.vue'
import SocialProjectList from './component/about/social-project/company-list.vue'
import SocialProjectDetail from './component/about/social-project/company-detail.vue'

import JobDetail from './component/job/job-detail.vue'
import JobPage from './component/job/job-page.vue'
import Jobs from './component/job/jobs.vue'

import DocumentPage from './component/document/document-page.vue'

import UserPage from './component/user/user-page.vue'
import UserLogin from './component/user/user-login.vue'

import Index from './component/index/index.vue'
Vue.use(VueRouter)

const router = new VueRouter({
  history: true,
  saveScrollPosition: true,
})

router.beforeEach(function (transition) {
  window.scrollTo(0, 0)
  transition.next()
})

const aboutRoutes = {
  component: AboutPage,
  subRoutes: {
    '/profile': {
      component: AboutProfile
    },
    '/team': {
      component: AboutTeams,
      subRoutes: {
        '/partner': {
          component:  AboutTeams,
        },
        '/investment': {
          component:  AboutTeams,
        },
        '/management': {
          component:  AboutTeams,
        },
      },
    },
    '/social-responsibility-projects': {
      component: SocialProjectPage,
      subRoutes: {
        '/': {
          component:  SocialProjectList,
        },
        '/:id/:slug': {
          component:  SocialProjectDetail,
        },
      },
    },
    '/corporate-governance': {
      component: AboutCorporateGovernance
    },
  }
}

const newsRoutes = {
  component: NewsPage,
  subRoutes: {
    '/financial': {
      component:  NewsFinancial,
    },
    '/announcement': {
      component:  NewsAnnouncement,
    },
    '/circular': {
      component:  NewsCircular,
    },
    '/media': {
      component:  NewsMedia,
    },
  }
}

const portfolioRoutes = {
  component: PortfolioPage,
  subRoutes: {
    '/': {
      component: PortfolioCompanyList
    },
    '/:cat/:id/:slug': {
      component:  PortfolioCompanyDetail,
    },
    '/:id': {
      component:  PortfolioCompanyDetail,
    },
  }
}
const jobDetailRoutes = {
  component: JobDetail,
}
const jobRoutes = {
  component: JobPage,
  subRoutes: {
    '/:category': {
      component:  Jobs,
      subRoutes: {
        '/:id': {
          component:  Jobs,
        },
      }
    },
  }
}

router.map({
  '/': {
    component: Index
  },
  '/about': aboutRoutes,
  'about/team/:team/:id/:name': {
    component: PersonPage
  },
  '/contact':{
    component: ContactPage
  },
  '/disclaimer': {
    component: DisclaimerPage
  },
  '/news': newsRoutes,
  '/portfolio': portfolioRoutes,
  '/job/detail/:id/:name': jobDetailRoutes,
  '/job/detail/:id': jobDetailRoutes,
  '/job': jobRoutes,
  '/downloads': { component: DocumentPage },
  '/login': { component: UserLogin },
})

export default router;



// WEBPACK FOOTER //
// ./assets/router.js